export type HeadlessTableColNode = {
  type?: string;
  width?: number | string;
  alignment?: string;
  color_scheme?: string[];
};

export type HeadlessTableSectionRow = {
  kind: 'section';
  label: string;
};

export type HeadlessTableMetricRow = {
  kind: 'metric';
  cells: string[];
};

export type HeadlessTableRow = HeadlessTableSectionRow | HeadlessTableMetricRow;

/** Convert BE headless-table `data` entries into render rows. */
export function parseHeadlessTableData(data: unknown): HeadlessTableRow[] {
  if (!Array.isArray(data)) return [];

  const rows: HeadlessTableRow[] = [];
  for (const entry of data) {
    if (typeof entry === 'string') {
      const label = entry.trim();
      if (!label) continue;
      rows.push({ kind: 'section', label });
      continue;
    }
    if (Array.isArray(entry)) {
      rows.push({
        kind: 'metric',
        cells: entry.map(cell => (cell === null || cell === undefined ? '' : String(cell))),
      });
    }
  }
  return rows;
}

export function resolveHeadlessColumnCount(
  colNodes: HeadlessTableColNode[] | undefined,
  rows: HeadlessTableRow[],
): number {
  const fromCols = Array.isArray(colNodes) ? colNodes.length : 0;
  const fromRows = rows.reduce((max, row) => {
    if (row.kind === 'metric') return Math.max(max, row.cells.length);
    return Math.max(max, 1);
  }, 0);
  return Math.max(fromCols, fromRows, 2);
}

/** Label-heavy defaults so the name column wraps less often than a 50/50 split. */
export function resolveHeadlessColumnWidth(
  _colNode: HeadlessTableColNode | undefined,
  columnCount: number,
  columnIndex = 0,
): string {
  const count = Math.max(columnCount, 1);
  if (count === 1) return '100%';
  if (count === 2) {
    return columnIndex === 0 ? '70%' : '30%';
  }
  if (columnIndex === 0) return '45%';
  return `${(55 / (count - 1)).toFixed(4).replace(/\.?0+$/, '')}%`;
}
